import { DefaultProduct } from './_defaults';

export default () => ({
  DefaultProduct,
});
